import { render, staticRenderFns } from "./ItemLinksField.vue?vue&type=template&id=c0693d10&scoped=true&"
import script from "./ItemLinksField.vue?vue&type=script&lang=js&"
export * from "./ItemLinksField.vue?vue&type=script&lang=js&"
import style0 from "./ItemLinksField.vue?vue&type=style&index=0&id=c0693d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0693d10",
  null
  
)

export default component.exports